import { render, staticRenderFns } from "./SriImportModal.vue?vue&type=template&id=53a6b67d&scoped=true"
import script from "./SriImportModal.vue?vue&type=script&lang=js"
export * from "./SriImportModal.vue?vue&type=script&lang=js"
import style0 from "./SriImportModal.vue?vue&type=style&index=0&id=53a6b67d&prod&lang=scss"
import style1 from "./SriImportModal.vue?vue&type=style&index=1&id=53a6b67d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6b67d",
  null
  
)

export default component.exports